import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export async function submitLead(payload) {
  const { data } = await api.post("/leads", payload);
  return data;
}

export async function adminLogin(password) {
  const { data } = await api.post("/admin/login", { password });
  return data;
}

export async function fetchLeads(password) {
  const { data } = await api.get("/admin/leads", {
    headers: { "X-Admin-Password": password },
  });
  return data;
}

export async function fetchStats(password) {
  const { data } = await api.get("/admin/stats", {
    headers: { "X-Admin-Password": password },
  });
  return data;
}

export async function updateLeadStatus(password, id, status) {
  const { data } = await api.patch(
    `/admin/leads/${id}`,
    { status },
    { headers: { "X-Admin-Password": password } },
  );
  return data;
}

export async function deleteLead(password, id) {
  const { data } = await api.delete(`/admin/leads/${id}`, {
    headers: { "X-Admin-Password": password },
  });
  return data;
}
